export default __webpack_public_path__ + "static/media/leader_notes.2fc8b144.pdf";